export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-white py-12">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          <div>
            <h3 className="text-2xl font-bold mb-4">Ragdoll Gentle Paws Adoption</h3>
            <p className="text-gray-400 leading-relaxed">
              Ethical Breeding • Healthy Kittens • Loving Homes
            </p>
          </div>

          <div>
            <h4 className="text-xl font-bold mb-4">Contact</h4>
            <div className="space-y-2 text-gray-400">
              <p>
                <a 
                  href="mailto:ragdollgentlepawsadoption@gmail.com"
                  className="hover:text-blue-400 transition-colors cursor-pointer"
                >
                  ragdollgentlepawsadoption@gmail.com
                </a>
              </p>
              <p>Phone: 727-300-7541</p>
            </div>
          </div>

          <div>
            <h4 className="text-xl font-bold mb-4">Follow Us</h4>
            <div className="flex gap-4">
              <a 
                href="#" 
                className="w-10 h-10 bg-blue-400 rounded-full flex items-center justify-center hover:bg-blue-500 transition-colors cursor-pointer"
              >
                <i className="ri-instagram-line text-xl"></i>
              </a>
              <a 
                href="#" 
                className="w-10 h-10 bg-blue-400 rounded-full flex items-center justify-center hover:bg-blue-500 transition-colors cursor-pointer"
              >
                <i className="ri-tiktok-fill text-xl"></i>
              </a>
              <a 
                href="#" 
                className="w-10 h-10 bg-blue-400 rounded-full flex items-center justify-center hover:bg-blue-500 transition-colors cursor-pointer"
              >
                <i className="ri-facebook-fill text-xl"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 text-center text-gray-400">
          <p className="mb-2">
            © {currentYear} Ragdoll Gentle Paws Adoption. All rights reserved.
          </p>
          <p>
            <a 
              href="https://readdy.ai/?origin=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="hover:text-blue-400 transition-colors cursor-pointer"
            >
              Website Builder
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
